













































































































import Vue from 'vue'
import Component from "vue-class-component";
import {Getter, Action} from "vuex-class";
import {cloneDeep, isEqual} from "lodash";
import { CollapseTransition } from "vue2-transitions";
import {
  SelectWings,
  DatePickerWings,
  ToggleWings,
  Collapse,
  SpoilerWings,
  TimeoutWings,
  InputWings,
  TextareaWings
} from 'wings-ui-components';
import {OriginatorItem} from "@/store/settings/originators/types";
import { notifyError, notifyDelete, notifyConfirm } from '@/utils/notify-helper';
import {Ref, Watch} from "vue-property-decorator";
import { MsgTransports } from '@/store/types';
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";
import {PartnerItem} from "@/store/settings/partners/types";

Component.registerHooks([
  'beforeRouteLeave',
])

@Component({components: {
    SelectWings,
    DatePickerWings,
    ToggleWings,
    Collapse,
    SpoilerWings,
    CollapseTransition,
    TimeoutWings,
    InputWings,
    TextareaWings
}})
export default class Originator extends Vue {
  @Ref('validator') validator:any;

  // @Getter("partners") partnersList: any;
  @Getter("transports") transportsList: any;
  @Getter("originatorStatusList") statusList: any;

  @Action("getOriginatorItem") actionGetItem: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getTransports") actionGetTransports: any;
  @Action("saveOriginator") actionSave: any;
  @Action("deleteOriginator") actionDelete: any;
  @Action("actionLog") actionLog: any;

  partnersList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners(filter);
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  get transportsForOriginatorsList() {
    let list = this.transportsList.filter((e:any) => ![MsgTransports.PUSH, MsgTransports.MAILNOTIFY].includes(e.name))

    if (!this.transportsList.some((e:any) => e.id === this.item?.transport_id)) {
      list.push({
        id: this.item?.transport_id,
        name: this.item?.transport,
        is_hide: true
      })
    }

    return list
  }

  defaultItem(): OriginatorItem {
    return {
      originator: "",
      partner_id: null,
      transport_id: null,
      status_id: null,
      description: "",
    };
  }

  private item = this.defaultItem();
  private itemSaved = this.defaultItem();
  private logObject: ActionLog = {};
  private transportNames: string[] = ['sms', 'call', 'email', 'viber', 'whatsapp', 'custom'];

  get originatorRules() {
    let initialRule = 'required';
    if (this.item.transport_id) {
      switch (this.item.transport_id) {
        case 1:
          return `${initialRule}|sms_originator`;
        case 2:
          return `${initialRule}|max:15|call_originator`;
        case 3:
          return `${initialRule}|max:200|email_originator|non_cyrillic`;
        case 6:
          return `${initialRule}|viber_originator`;
        case 7:
          return `${initialRule}|whatsapp_originator`;
        default:
          return initialRule;
      }
    }
    return initialRule;
  }

  async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Originator"
        }
        const data = await this.actionGetItem(this.$route.params.id);
        this.item = Object.assign({},this.item, data);
        this.itemSaved = cloneDeep(Object.assign({},this.item, data));
        this.logObject.object_name = this.item.originator;
        this.actionLog(this.logObject);
      } catch (error) {
        this.actionLog({...this.logObject, action_status: "failed"});
      }
      this.partnersList = await this.actionGetPartners({id: this.item.partner_id});
    }
  }

  back():void{
    this.$router.push('/settings/originators/');
  }

  onSaveItem():Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid:boolean = await this.validator.validate();
      if (valid) {
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: this.$route.params.id ? "Editing" : "Creation",
            action_status: "success",
            object_type: "Originator",
            object_name : this.item.originator,
            addititional_info: getTranslatedParams(this.item)
          }
          await this.actionSave(this.item);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          resolve();
          this.back();
        } catch (error) {
          await this.actionLog({...this.logObject, action_status: "failed"});
          reject();
          notifyError(error);
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    })
  }

  async onDeleteItem():Promise<void> {
    let isConfirm:boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Originator",
          object_name : this.item.originator,
          addititional_info: getTranslatedParams({id: this.item.id})
        }
        await this.actionDelete(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  get filteredPartners(): PartnerItem[] {
    return this.partnersList.filter((partner: PartnerItem) => {
      return partner?.transport_names.some(transportName =>
          this.transportNames.includes(transportName.toLowerCase())
      );
    });
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item,this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  @Watch('item.status_id')
  onStatusChanged(val?: number, oldVal?: number) {
    if ( val !== 3) {
      this.item.description = null;
    }
  }

  @Watch('item.partner_id', {immediate: true})
  onChangePartner(val: number, oldVal: number) {
    if (val) {
      this.actionGetTransports({partner_id: val});
    }
    if (oldVal && val !== oldVal){
      this.item.transport_id = null;
    }
  }
}
